import Vue from 'vue'

// define a bus to propagate event in the whole application
export const EventBus = new Vue()



// WEBPACK FOOTER //
// ./src/event-bus.js